import { render, staticRenderFns } from "./TaskSelectInput.vue?vue&type=template&id=6cb989ce&scoped=true&"
import script from "./TaskSelectInput.vue?vue&type=script&lang=js&"
export * from "./TaskSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./TaskSelectInput.vue?vue&type=style&index=0&id=6cb989ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb989ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VIcon,VSelect})
